import { NgModule } from '@angular/core';
import { InputTextModule } from 'primeng/inputtext';
import { ButtonModule } from 'primeng/button';
import { PanelModule } from 'primeng/panel';
import { ToastModule } from 'primeng/toast';
import { MegaMenuModule } from 'primeng/megamenu';
import { TableModule } from 'primeng/table';
import { MessageModule } from 'primeng/message';
import { CardModule } from 'primeng/card';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { OverlayPanelModule } from 'primeng/overlaypanel';
import { BreadcrumbModule } from 'primeng/breadcrumb';
import { CalendarModule } from 'primeng/calendar';
import { SidebarModule } from 'primeng/sidebar';
import { MessagesModule } from 'primeng/messages';
import { AccordionModule } from "primeng/accordion";
import { FocusTrapModule } from 'primeng/focustrap';
import { PickListModule } from 'primeng/picklist';
import { DropdownModule } from 'primeng/dropdown';
import { SelectButtonModule } from 'primeng/selectbutton';
import { ToggleButtonModule } from 'primeng/togglebutton';
import { MessageService, ConfirmationService } from 'primeng/api';
import { InputSwitchModule} from 'primeng/inputswitch';
import { CheckboxModule } from 'primeng/checkbox';
import { DataViewModule } from 'primeng/dataview';
import { DialogModule } from 'primeng/dialog';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { MultiSelectModule } from 'primeng/multiselect';
import { MenubarModule } from 'primeng/menubar';
import { MenuModule } from 'primeng/menu';
import {BadgeModule} from 'primeng/badge';
import { InputNumberModule } from 'primeng/inputnumber';
import { TooltipModule } from 'primeng/tooltip';
import {TabMenuModule} from 'primeng/tabmenu';
import {TabViewModule} from 'primeng/tabview';
import {TieredMenuModule} from 'primeng/tieredmenu';
import {ListboxModule} from 'primeng/listbox';

@NgModule({
  exports: [
    AccordionModule,
    InputTextModule,
    ButtonModule,
    PanelModule,
    ToastModule,
    MegaMenuModule,
    TableModule,
    MessageModule,
    CardModule,
    ProgressSpinnerModule,
    OverlayPanelModule,
    BreadcrumbModule,
    CalendarModule,
    SidebarModule,
    MessagesModule,
    FocusTrapModule,
    PickListModule,
    DropdownModule,
    SelectButtonModule,
    ToggleButtonModule,
    InputSwitchModule,
    CheckboxModule,
    DataViewModule,
    ConfirmDialogModule,
    DialogModule,
    MultiSelectModule,
    MenubarModule,
    MenuModule,
    BadgeModule,
    InputNumberModule,
    TooltipModule,
    TabMenuModule,
    TabViewModule,
    TieredMenuModule,
    ListboxModule
  ],
  providers: [MessageService, ConfirmationService]
})
export class NgPrimeModule { }
